export default "__VITE_ASSET__344e703f__"